import { startCase } from 'lodash';

const columnTotal = (data) => {
  const { table = [], lookups: { g2: g2Hash = {} } = {} } = data;

  const result = table?.reduce((acc, curr) => {
    const [data] = curr;
    for (let j = 0; j < data?.length; j++) {
      // eslint-disable-next-line
      const [ds, dt, g1, g2, applied, interviewed, offered, hired, rejected] =
        data[j];
      acc[g2Hash[g2]] = acc[g2Hash[g2]] || {};
      acc[g2Hash[g2]]['applied'] = (acc[g2Hash[g2]]['applied'] || 0) + applied;
      acc[g2Hash[g2]]['interviewed'] =
        (acc[g2Hash[g2]]['interviewed'] || 0) + interviewed;
      acc[g2Hash[g2]]['offered'] = (acc[g2Hash[g2]]['offered'] || 0) + offered;
      acc[g2Hash[g2]]['hired'] = (acc[g2Hash[g2]]['hired'] || 0) + hired;
      acc[g2Hash[g2]]['rejected'] =
        (acc[g2Hash[g2]]['rejected'] || 0) + rejected;
    }
    return acc;
  }, {});

  return result;
};

const rowTotal = (data) => {
  const { table = [] } = data;
  return table?.reduce(
    (acc, curr) => {
      // eslint-disable-next-line
      const [ds, dt, g1, g2, applied, interviewed, offered, hired, rejected] =
        curr;
      acc.applied = acc.applied + applied;
      acc.hired = acc.hired + hired;
      return acc;
    },
    { applied: 0, hired: 0 }
  );
};

const getMatrixData = (response) => {
  const {
    table = [],
    headers = [],
    lookups: { g1 = undefined, g2 = undefined } = {},
  } = response || {};
  const cTotal = columnTotal(response);
  const rTotal = rowTotal(response);
  return table?.reduce((acc, row, index) => {
    const rowItems = g2?.reduce((acc, _g2Key, index) => {
      const datum = row[0][index] ?? [];
      const obj = {};
      headers.forEach((key, index) => {
        obj[key] = datum[index] ?? 0;
      });
      const key = g2?.[datum[3]];
      acc[key] = obj;
      return acc;
    }, {});

    const total = {};
    headers.forEach((key, index) => {
      total[key] = row[index] ?? 0;
    });

    const obj = {
      header: startCase(g1[index]),
      ...total,
      ...rowItems,
      columnTotal: cTotal,
      rowTotal: rTotal,
    };
    acc.push(obj);
    return acc;
  }, []);
};

export const eeoTableTransformer = ({ response }) => {
  return getMatrixData(response);
};
